import React, { Fragment } from 'react';
import { times } from 'lodash-es';

import Skeleton from '../../../../components/Skeleton';

export default {
  forecastHeader: (
    <div className="reports-and-exports-page__nav">
      <div className="reports-and-exports-page__nav-item">
        <Skeleton height={22} width={200} />
      </div>
    </div>
  ),
  forecastStats: (
    <>
      <div className="forecasts-main-sidebar__stats-current mb-xxs">
        <Skeleton height={18} />
      </div>
      <div className="forecasts-main-sidebar__stats-current">
        <Skeleton height={18} />
      </div>
    </>
  ),
  forecastsSidebarValues: (
    <div className="forecasts-main-sidebar__values">
      {times(4).map((n) => (
        <div key={n} className="forecasts-main-sidebar__values-item p-a-0 bg-none">
          <Skeleton height={64} />
        </div>
      ))}
    </div>
  ),
  forecastsSidebarTakeaways: (
    <div className="forecasts-main-sidebar__takeaways-content">
      <Skeleton height={150} />
    </div>
  ),
  forecastsMainChart: <Skeleton height={291} />,
  forecastsMainTable: <Skeleton height={187} />,
  sidebar: (
    <>
      {times(3).map((n) => (
        <Skeleton key={n} height={80} borderRadius={8} />
      ))}
    </>
  ),
};
